<template>
  <CustomLink
    :url="item.url"
    :type="LINK_TYPE.NoStyle"
    :is-block="true"
    class="flex flex-col grow"
  >
    <ImgView
      v-if="item.image"
      :img-classes="`w-full h-[100px] lg:h-[150px] object-cover object-center`"
      :src="item.image"
      :height="imageHeight"
    />
    <div
      :class="`${textColor} ${backgroundColor}`"
      class="flex items-center h-full p-3"
    >
      <ImgView
        v-if="item.icon"
        :src="item.icon"
        :height="24"
        :img-classes="`w-6 h-6 mr-2 object-cover object-center`"
      />
      <p>{{ item.title }}</p>
    </div>
  </CustomLink>
</template>
<script lang="ts">
import ImgView from '~/components/atoms/ImgView/ImgView.vue';
import type { ProductGroupsItemType } from '~~/types/cms/ProductGroupsItem';
import isString from '~~/helpers/dataStructure/isString';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import CustomLink from '~/components/atoms/Link/CustomLink.vue';

export default defineComponent({
  name: 'ProductGroupsItem',
  components: {
    ImgView,
    CustomLink,
  },
  props: {
    item: {
      type: Object as PropType<ProductGroupsItemType>,
      required: true,
      validator(item: ProductGroupsItemType) {

        return (
          isString(item.url) &&
          isString(item.title) &&
          (isString(item.image) || isString(item.icon))
        );
      
      },
    },
    imageHeight: {
      type: Number,
      default: 150,
    },
    textColor: {
      type: String,
      default: 'text-EXPONDO-black',
    },
    backgroundColor: {
      type: String,
      default: 'bg-EXPONDO-grey-5',
    },
  },
  setup() {

    return { LINK_TYPE };
  
  },
});
</script>
